import $ from 'jquery';

$(function () {
    const $trigger = $('.scroll-trigger');

    if ($trigger.length) {
        $trigger.on('click', function () {
            let $parentBlock = $trigger.parents('.block');

            $('html, body').animate({
                scrollTop: $parentBlock.offset().top + $parentBlock.height()
            });
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/ScrollTrigger.js